<template>
  <div class="container">
    <p v-if="!hasGameStateLoaded">Loading...</p>
    <template v-else>
      <game-lobby v-if="inLobby" />
      <game-layout class="game-layout" v-else />
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import shortid from 'shortid';
import { NS_GAME_STATE } from "@/store/constants";
import { ROUTE_NEW_GAME, ROUTE_HOME } from "@/router/constants";
import GameLobby from '@/components/GameLobby';
import GameLayout from "@/components/GameLayout";

export default {
  name: 'Game',

  components: {
    GameLayout,
    GameLobby,
  },

  props: {
    gameId: {
      type: String,
      default: null,
    }
  },

  data() {
    return {}
  },

  computed: {
    ...mapState(NS_GAME_STATE, [
      'hasGameStateLoaded',
    ]),

    ...mapGetters(NS_GAME_STATE, {
      players: 'players',
      isPlayerInGame: 'isPlayerInGame',
      inLobby: 'inLobby',
    }),
  },

  beforeRouteLeave(to, from, next) {
    this.setPlayerOffline();
    next();
  },

  async created() {
    if (!shortid.isValid(this.gameId)){
      console.error('invalid game id');
      this.$router.push({ name: ROUTE_NEW_GAME });
      return;
    }

    await this.loadGameDataFromLocalStorage();

    this.setGameId(this.gameId);
    await this.registerListener();
  },

  watch: {
    isPlayerInGame (isPlayerInGame) {
      console.log('isPlayerInGame', isPlayerInGame, !isPlayerInGame);
      // If this player got kicked and is no longer in the game, remove their local state
      if (!isPlayerInGame) {
        this.handleKickPlayer();
        this.$router.push({ name: ROUTE_HOME });
      }
    },

    // tilesPerHotel (tilesPerHotel) {
    //   // TODO: check for dead tiles and remove them
    //   // TODO:
    //   tilesPerHotel.forEach() {
    //
    //   }
    // },
  },

  methods: {
    ...mapActions(NS_GAME_STATE, [
      'registerListener',
      'loadGameDataFromLocalStorage',
      'setPlayerOffline',
      'removeGameDataFromLocalStorage',
      'handleKickPlayer',
    ]),

    ...mapMutations(NS_GAME_STATE, [
      'setGameId',
    ]),
  },
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
}

.game-layout {
  margin-bottom: 100px;
  border: 1px solid #0000001f;
  box-shadow: 5px 5px 5px #00000030;
  border-radius: 5px;
}

@media screen and (min-width: 1250px) {
  .game-layout {
    border: 0;
    box-shadow: none;
  }
}
</style>
